import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    root: {
        flex: 1,
        justifyContent: 'space-between',
        paddingLeft: 72,
        paddingTop: 64,
    },
});

export default styles;
